import navbar from '@/components/NavBar.vue';
import treatmentCreateOrderComponent from '@/components/wizardTreatment/treatmentCreateOrder/index.vue';
import PopupConfirmWizardExit from '@/components/wizardTreatment/popupConfirmWizardExit/index.vue';
import { mapState } from 'vuex';

export default {
  name: 'treatment-create-order',
  components: {
    navbar,
    treatmentCreateOrderComponent,
    PopupConfirmWizardExit
  },
  props: [],
  data() {
    return {

    };
  },

  computed: {
    ...mapState('Plantation', ['currentPlantation']),
  },
  mounted() {

  },
  methods: {

  },
};
